"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function ApartmentSearchPopoverItem({
  buttonProps = {},
  children = "",
  showDisabled = true,
  showEnabled = false,
  text = "This is the default text value",
}) {
  return (
    <Block className={"div-block-77"} tag={"div"}>
      {showDisabled ? (
        <Link
          block={"inline"}
          button={false}
          className={"search-results-link-block"}
          options={{
            href: "#",
          }}
          {...buttonProps}
        >
          <Block className={"search-results---submarket-container"} tag={"div"}>
            {children ?? (
              <Block className={"results-text-blcok large"} tag={"div"}>
                {text}
              </Block>
            )}
          </Block>
        </Link>
      ) : null}
      {showEnabled ? (
        <Block className={"search-results-link-block enabled"} tag={"div"}>
          <Block className={"search-results---submarket-container"} tag={"div"}>
            {children ?? (
              <Block className={"results-text-blcok large"} tag={"div"}>
                {text}
              </Block>
            )}
          </Block>
        </Block>
      ) : null}
    </Block>
  );
}
